import styled from 'styled-components'

interface BorderProps {
  $color: string
  $selected?: boolean
}

interface BackgroundProps {
  $color: string
}

export const Border = styled.div<BorderProps>`
  background-color: ${({ $selected }) => ($selected ? 'white' : 'transparent')};
  border: 2px solid
    ${({ $color, $selected }) => ($selected ? $color : 'transparent')};
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Background = styled.div<BackgroundProps>`
  background-color: ${({ $color }) => $color};
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`
